import { useMemo } from 'react';

import { isMatching } from 'utility/Check/isMatching';

import { ListItem } from '../types';

export const useFilteredList = (
    list: ListItem[],
    filter: string,
    currentSelection: Set<number>
): ListItem[] =>
    useMemo(
        () =>
            list.filter(
                (item) =>
                    currentSelection.has(item.id) ||
                    !filter ||
                    isMatching(item.name, filter)
            ),
        [currentSelection, filter, list]
    );
